import React from "react";

/* JsonLd
   ------
   Lightweight Schema.org JSON-LD emitter. Renders a single
   <script type="application/ld+json"> tag wherever it is placed
   in the component tree.

   Because the site is statically pre-rendered (see /app/frontend/prerender.js),
   the serialised JSON ends up in the final HTML shipped to crawlers –
   Googlebot can pick it up without needing to execute JavaScript.

   Pass a single Schema.org object as the `data` prop. For multiple
   schemas on the same page, render multiple <JsonLd> components.

   Usage:
     <JsonLd data={{
       "@context": "https://schema.org",
       "@type": "Course",
       "name": "Online BSL Course",
       ...
     }} />
*/
const JsonLd = ({ data }) => {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      // dangerouslySetInnerHTML is the documented way to inject JSON-LD
      // in React. The JSON is generated server/build-side; no user input.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};

export default JsonLd;
